export default __webpack_public_path__ + "static/logo-91f69642b9ee0251fc284c48f42565d7.svg";